import { isUsLocale } from "@/lib/market";
// A/B test for a "save this design" card on the preview page, on /en only, cars and motorcycles
// only.
//
// control = the shipped page.
// save    = an inline card under the add-to-cart: one email field, one button. The shopper who is
//           not ready to buy gets the design mailed to them, then two follow-ups (+24h social proof
//           and shipping, +72h last call). No discount anywhere in the sequence.
//
// The bet: most preview visitors leave without buying and without ever giving us an address, so
// nothing brings them back. A shopper who is not ready today is not lost if the design is in their
// inbox tomorrow.
//
// nl/de never enter the test, and a pet job never does either: the pets line has its own funnel
// and must not move a car test. Both render control.
//
// The PostHog Experiment on SAVE_DESIGN_FLAG: 100% rollout, 50/50 split, exposure event
// SAVE_DESIGN_VIEW_EVENT.

export const SAVE_DESIGN_FLAG = "preview-save-design-v1";

export const SAVE_DESIGN_VIEW_EVENT = "preview_save_design_view";

export const SAVE_DESIGN_SAVED_EVENT = "preview_design_saved";

export type SaveDesignVariant = "control" | "save";

/** Only the US site carries the test; the UK always renders control. */
export function supportsSaveDesign(locale: string | undefined): boolean {
  return isUsLocale(locale);
}

export function isSaveDesignVariant(value: unknown): value is SaveDesignVariant {
  return value === "control" || value === "save";
}

/** Whether this variant draws the save-design card. */
export function showsSaveDesign(variant: SaveDesignVariant): boolean {
  return variant === "save";
}

/**
 * The variant to render, decided on the server from the PostHog flags. Anything other than a
 * clear "save" on /en falls back to the shipped page, so a timed-out or blocked flag fetch ships
 * control. Dev has no PostHog identity to evaluate against, so it falls through to the new arm —
 * `?save_design=control` opens the other one.
 */
export function resolveSaveDesignVariant(
  locale: string | undefined,
  flags: Record<string, string | boolean> | undefined,
): SaveDesignVariant {
  if (!supportsSaveDesign(locale)) return "control";
  if (flags?.[SAVE_DESIGN_FLAG] === "save") return "save";
  if (process.env.NODE_ENV === "development") return "save";
  return "control";
}
